import styled from "styled-components";

export const Wrapper = styled.div`
  opacity: ${(props) => (props.enabled ? 1 : 0.5)};
  pointer-event: ${(props) => (props.enabled ? "auto" : "none")};
`;
